import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export const isRespAdmin = (u) => !!u && (u.role === "admin" || u.role === "responsabile");

export const RUOLI_LABEL = {
  admin: "Amministratore",
  responsabile: "Responsabile",
  animatore: "Animatore",
  aiuto_animatore: "Aiuto Animatore",
  genitore: "Genitore",
};
